var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLashesDownNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135,
    height: 38,
    viewBox: "0 0 135 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 135,
    height: 38
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_98",
    x: 8.677,
    y: 19.751,
    width: 42.986,
    height: 14.229,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#75798c",
    floodOpacity: 0.588
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_99",
    x: 83.339,
    y: 19.761,
    width: 42.986,
    height: 14.229,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#75798c",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lashes-down-new",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lashes-down",
    transform: "translate(-0.176 0.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "left",
    transform: "translate(5.283 4.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -5.11, -4.56)",
    filter: "url(#Path_98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_98-2",
    "data-name": "Path 98",
    d: "M17.34,7.047c9.247,0,19.646-8.229,19.646-8.229s-10.4,4.6-19.646,4.6A39.49,39.49,0,0,1,0-1.182S8.094,7.047,17.34,7.047Z",
    transform: "translate(11.68 22.93)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_98-3",
    "data-name": "Path 98",
    d: "M17.34,7.047c9.247,0,19.646-8.229,19.646-8.229s-10.4,4.6-19.646,4.6A39.49,39.49,0,0,1,0-1.182S8.094,7.047,17.34,7.047Z",
    transform: "translate(6.57 18.37)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0 18.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M322.349,240.75a4.787,4.787,0,0,1-2.791,3.206c-2.18.716-5.928-.341-5.928-.341s3.173,1.671,5.726,1.079,4.487-3.446,4.487-3.446-.853,3.254-2.876,4.687-5.434.2-5.434.2,3.517,1.675,5.937.671,3.743-4.687,3.743-4.687A15.765,15.765,0,0,1,323.125,247a5.1,5.1,0,0,1-3.192,1.888,5.867,5.867,0,0,0,4.12-1.167c1.756-1.473,2.9-4.725,2.9-4.725Z",
    transform: "translate(-313.63 -240.75)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M5.565,0A5.811,5.811,0,0,1,3.723,3.338,18.6,18.6,0,0,1,0,5.493a15.908,15.908,0,0,0,3.821-.949A5.611,5.611,0,0,0,6.865.994,6.824,6.824,0,0,1,5.427,4.739,9.429,9.429,0,0,1,1.552,6.925,9.487,9.487,0,0,0,6.026,5.857,4.959,4.959,0,0,0,8.143,2.045,7.705,7.705,0,0,1,7.462,5.52c-.809,1.681-3.41,2.8-3.41,2.8A13.1,13.1,0,0,0,7.858,6.56C9.164,5.5,9.424,3.083,9.424,3.083Z",
    transform: "translate(8.084 4.553) rotate(-20.972)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M3.367,0A9.032,9.032,0,0,1,2.156,2.569,5.837,5.837,0,0,1,0,4.509,6.06,6.06,0,0,0,2.8,3.13,4.145,4.145,0,0,0,4.137.915a2.02,2.02,0,0,1-.126,2.6,7.64,7.64,0,0,1-1.943,2.1A6.632,6.632,0,0,0,4.722,3.953,5.543,5.543,0,0,0,5.78,1.2,3.9,3.9,0,0,1,5.8,3.512,9.432,9.432,0,0,1,4.24,6.137,5.036,5.036,0,0,0,6.185,4.429,3.636,3.636,0,0,0,6.831,2.3Z",
    transform: "matrix(0.934, -0.358, 0.358, 0.934, 16.258, 6.16)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M2.947,0a7.5,7.5,0,0,1-1.06,2.17A5.068,5.068,0,0,1,0,3.81,5.394,5.394,0,0,0,2.452,2.645,3.469,3.469,0,0,0,3.621.773a1.663,1.663,0,0,1-.11,2.193,6.571,6.571,0,0,1-1.7,1.771,5.852,5.852,0,0,0,2.322-1.4,4.58,4.58,0,0,0,.926-2.329,3.185,3.185,0,0,1,.018,1.956A7.928,7.928,0,0,1,3.712,5.185a4.377,4.377,0,0,0,1.7-1.443,2.991,2.991,0,0,0,.565-1.8Z",
    transform: "matrix(0.755, -0.656, 0.656, 0.755, 22.426, 6.755)",
    fill: "#62616d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "right",
    transform: "translate(87.515 4.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -87.34, -4.56)",
    filter: "url(#Path_99)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_99-2",
    "data-name": "Path 99",
    d: "M19.646,7.047C10.4,7.047,0-1.182,0-1.182s10.4,4.6,19.646,4.6a39.49,39.49,0,0,0,17.34-4.6S28.893,7.047,19.646,7.047Z",
    transform: "translate(86.34 22.94)",
    fill: "#62616d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_99-3",
    "data-name": "Path 99",
    d: "M19.646,7.047C10.4,7.047,0-1.182,0-1.182s10.4,4.6,19.646,4.6a39.49,39.49,0,0,0,17.34-4.6S28.893,7.047,19.646,7.047Z",
    transform: "translate(-1 18.38)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(12.212 18.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_128-2",
    "data-name": "Path 128",
    d: "M318.238,240.75a4.787,4.787,0,0,0,2.791,3.206c2.18.716,5.928-.341,5.928-.341s-3.173,1.671-5.726,1.079-4.487-3.446-4.487-3.446.853,3.254,2.876,4.687,5.434.2,5.434.2-3.517,1.675-5.937.671-3.743-4.687-3.743-4.687A15.765,15.765,0,0,0,317.462,247a5.1,5.1,0,0,0,3.192,1.888,5.867,5.867,0,0,1-4.12-1.167c-1.756-1.473-2.9-4.725-2.9-4.725Z",
    transform: "translate(-296.614 -240.75)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129-2",
    "data-name": "Path 129",
    d: "M5.565,8.322A5.811,5.811,0,0,0,3.723,4.984,18.6,18.6,0,0,0,0,2.829a15.908,15.908,0,0,1,3.821.949,5.611,5.611,0,0,1,3.044,3.55A6.824,6.824,0,0,0,5.427,3.582,9.429,9.429,0,0,0,1.552,1.4,9.487,9.487,0,0,1,6.026,2.465,4.959,4.959,0,0,1,8.143,6.277,7.7,7.7,0,0,0,7.462,2.8C6.654,1.12,4.052,0,4.052,0A13.1,13.1,0,0,1,7.858,1.762C9.164,2.821,9.424,5.239,9.424,5.239Z",
    transform: "matrix(-0.934, -0.358, 0.358, -0.934, 19.276, 12.323)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130-2",
    "data-name": "Path 130",
    d: "M3.367,6.137A9.032,9.032,0,0,0,2.156,3.568,5.837,5.837,0,0,0,0,1.628,6.06,6.06,0,0,1,2.8,3.007,4.145,4.145,0,0,1,4.137,5.222a2.02,2.02,0,0,0-.126-2.6A7.64,7.64,0,0,0,2.068.531,6.632,6.632,0,0,1,4.722,2.184,5.543,5.543,0,0,1,5.78,4.941,3.9,3.9,0,0,0,5.8,2.625,9.432,9.432,0,0,0,4.241,0,5.036,5.036,0,0,1,6.185,1.708,3.636,3.636,0,0,1,6.83,3.84Z",
    transform: "matrix(-0.934, -0.358, 0.358, -0.934, 11.885, 11.889)",
    fill: "#62616d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131-2",
    "data-name": "Path 131",
    d: "M2.947,5.185a7.5,7.5,0,0,0-1.06-2.17A5.068,5.068,0,0,0,0,1.376,5.394,5.394,0,0,1,2.452,2.54,3.469,3.469,0,0,1,3.621,4.412a1.663,1.663,0,0,0-.11-2.193A6.571,6.571,0,0,0,1.81.448a5.852,5.852,0,0,1,2.322,1.4,4.58,4.58,0,0,1,.926,2.329,3.185,3.185,0,0,0,.018-1.956A7.928,7.928,0,0,0,3.712,0a4.377,4.377,0,0,1,1.7,1.443,2.991,2.991,0,0,1,.565,1.8Z",
    transform: "matrix(-0.755, -0.656, 0.656, -0.755, 4.515, 10.668)",
    fill: "#62616d"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLashesDownNew);
export default __webpack_public_path__ + "static/media/lashes-down-new.aaa291a410ced6499746a967e891db10.svg";
export { ForwardRef as ReactComponent };